module.exports = __webpack_public_path__ + "static/media/12UNCTAD11.a03e0e3e.jpg";